import { render, staticRenderFns } from "./guidance-display-screen.vue?vue&type=template&id=196c5110"
import script from "./guidance-display-screen.vue?vue&type=script&lang=js"
export * from "./guidance-display-screen.vue?vue&type=script&lang=js"
import style0 from "./guidance-display-screen.vue?vue&type=style&index=0&id=196c5110&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports